import script from "./CopyRights.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyRights.vue?vue&type=script&setup=true&lang=ts"

import "./CopyRights.vue?vue&type=style&index=0&id=7b02b530&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b02b530"]])

export default __exports__